module.exports = __webpack_public_path__ + "static/media/路线规划.2816f4b2.jpg";